export default __webpack_public_path__ + "static/media/database-2018-01-05.905a3be6.csv";